<template>
    <button :disabled="disabled" v-bind:class="{'dark':dark}" :type="type" v-on:click="$emit('jbr-click')"
            :ref="buttonRefName">
        <slot></slot>
    </button>
</template>

<script>
    import {
        REF_BUTTON,
    } from '../services/constants'

    export default {
        name: 'jabra-btn',
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            dark: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: 'button',
            },
        },
        computed: {
            buttonRefName() {
                return REF_BUTTON
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    button {
        top: 0;
        box-shadow: 0 0 0 0;
        cursor: pointer;
        border: $accent-1 solid 1px;
        line-height: 28px;
        border-radius: 28px;
        padding: 0 36px;
        background: white;
        @include font-abraham(14px, $accent-1, 300);

        &:disabled {
            cursor: not-allowed;
            background: $grey-2;
            border-color: $grey-2;
            &.dark {
                background: $grey-2;
                border-color: $grey-2;
            }
        }
        &.dark {
            background: $accent-1;
            @include font-abraham(12px, white, 300);
        }
        &:not(:disabled):hover {
            position: relative;
            top: 1px;
            box-shadow: 0 3px 5px -2px $grey-2;
            transition: top .2s, box-shadow .2s;
        }
    }


</style>
